import { useI18n } from '../../i18n'
import type { CVPersonalInfo } from '../../types/cv'
import './editor.css'

export interface PersonalInfoEditorProps {
  data: CVPersonalInfo
  onChange: (data: Partial<CVPersonalInfo>) => void
}

/**
 * Personal information section editor
 */
export function PersonalInfoEditor({ data, onChange }: PersonalInfoEditorProps) {
  const { t } = useI18n()
  const handleChange =
    (field: keyof CVPersonalInfo) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange({ [field]: e.target.value })
    }

  return (
    <>
      <div className="editor-grid">
        <div className="editor-field">
          <label htmlFor="fullName">{t('fields.fullName')}</label>
          <input
            id="fullName"
            type="text"
            value={data.fullName}
            onChange={handleChange('fullName')}
            placeholder={t('placeholders.fullName')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="jobTitle">{t('fields.jobTitle')}</label>
          <input
            id="jobTitle"
            type="text"
            value={data.jobTitle}
            onChange={handleChange('jobTitle')}
            placeholder={t('placeholders.jobTitle')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="email">{t('fields.email')}</label>
          <input
            id="email"
            type="email"
            value={data.email}
            onChange={handleChange('email')}
            placeholder={t('placeholders.email')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="phone">{t('fields.phone')}</label>
          <input
            id="phone"
            type="tel"
            value={data.phone}
            onChange={handleChange('phone')}
            placeholder={t('placeholders.phone')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="city">{t('fields.city')}</label>
          <input
            id="city"
            type="text"
            value={data.city}
            onChange={handleChange('city')}
            placeholder={t('placeholders.city')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="country">{t('fields.country')}</label>
          <input
            id="country"
            type="text"
            value={data.country}
            onChange={handleChange('country')}
            placeholder={t('placeholders.country')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="linkedin">{t('fields.linkedin')}</label>
          <input
            id="linkedin"
            type="url"
            value={data.linkedin}
            onChange={handleChange('linkedin')}
            placeholder={t('placeholders.linkedin')}
          />
        </div>

        <div className="editor-field">
          <label htmlFor="website">{t('fields.website')}</label>
          <input
            id="website"
            type="url"
            value={data.website}
            onChange={handleChange('website')}
            placeholder={t('placeholders.website')}
          />
        </div>
      </div>

      <div className="editor-field editor-field-full">
        <label htmlFor="summary">{t('fields.summary')}</label>
        <textarea
          id="summary"
          className="editor-textarea-expanded"
          value={data.summary}
          onChange={handleChange('summary')}
          placeholder={t('placeholders.summary')}
          rows={6}
        />
      </div>
    </>
  )
}
